<template>
  <v-row align="center" class="px-4 pt-2" dense>
    <v-col cols="8">
      <v-select
        v-model="selected"
        :items="fareItems"
        item-text="label"
        item-value="code"
        label="Fare / promotion"
        :loading="$apollo.queries.azamaraFareCodes.loading || repricing"
        :disabled="repricing"
        :error-messages="errorMsg"
        dense
        hide-details="auto"
        @change="onChange"
      />
    </v-col>
    <v-col cols="4" class="caption grey--text">
      Prices are per cabin for the searched guests
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";

const FARE_CODES = gql`
  query azamaraFareCodes($rsResultSupplierId: ID!) {
    azamaraFareCodes(rsResultSupplierId: $rsResultSupplierId)
  }
`;

const REPRICE = gql`
  mutation azamaraSailingCategories($rsResultSupplierId: ID!, $fareCode: String) {
    azamaraSailingCategories(rsResultSupplierId: $rsResultSupplierId, fareCode: $fareCode) {
      id
      priceFrom
    }
  }
`;

// #11473 Promo picker for one Azamara sailing: lists CruiseFareAvail codes and
// re-prices the sailing's cabin categories with the chosen one.
export default {
  name: "azamara-fare-picker",

  props: {
    supplierId: {
      type: String,
      required: true,
    },
    fareCode: {
      type: String,
      default: "BESTPRICE",
    },
  },

  data() {
    return {
      selected: this.fareCode || "BESTPRICE",
      repricing: false,
      errorMsg: "",
    };
  },

  computed: {
    fareItems() {
      let codes = [];
      try {
        codes = JSON.parse(this.azamaraFareCodes || "[]") || [];
      } catch (e) {
        codes = [];
      }
      const items = codes.map((c) => ({
        code: c.fare_code,
        label: c.description && c.description != c.fare_code ? `${c.fare_code} – ${c.description}` : c.fare_code,
      }));
      if (!items.some((i) => i.code == this.selected)) {
        items.unshift({ code: this.selected, label: this.selected });
      }
      return items;
    },
  },

  watch: {
    fareCode(val) {
      this.selected = val || "BESTPRICE";
    },
  },

  methods: {
    onChange(code) {
      this.repricing = true;
      this.errorMsg = "";
      this.$apollo
        .mutate({
          mutation: REPRICE,
          variables: { rsResultSupplierId: this.supplierId, fareCode: code },
        })
        .then(() => {
          this.$emit("repriced", code);
        })
        .catch((error) => {
          this.errorMsg = error.message.replace("GraphQL error: ", "");
          this.selected = this.fareCode || "BESTPRICE";
        })
        .finally(() => {
          this.repricing = false;
        });
    },
  },

  apollo: {
    azamaraFareCodes: {
      query: FARE_CODES,
      variables() {
        return { rsResultSupplierId: this.supplierId };
      },
      fetchPolicy: "network-only",
      error(error) {
        this.errorMsg = error.message.replace("GraphQL error: ", "");
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/rates-search/AzamaraFarePicker.vue